var ngOUC = angular.module('OUC', ['ngRoute', 'ngResource', 'ngSanitize', 'me-lazyload']);

var OucGlobals = {
    base                : 'map',
    pathToPropertyReport: '/wp-content/themes/oucecon/map/property-report.php',
    kmlDirectory        : '/wp-content/themes/oucecon/map/kml',
    templatesDirectory  : '/wp-content/themes/oucecon/map/dist/views',
    mediaDirectory      : '/wp-content/themes/oucecon/map/dist/media',
    properties          : [],
    apiUrl              : '/wp-content/themes/oucecon/map/properties/properties.json'
};

// ******
// These filters are used in the property-bar  
// for the pdf see the filters in property-report.php
// ******
ngOUC.filter('yesNo', function () {
    return function (input) {
        if (input === '' || input === null) {
            return 'Unknown';
        }

        return input ? 'Yes' : 'No';
    }
});

ngOUC.filter('orNoData', function () {
    return function (input) {
        return input ? input : 'No data';
    }
});

ngOUC.filter('keys', function () {
    return function (input) {
        return Object.keys(input);
    }
});

ngOUC.filter('address2', function() {
    return function (input) {
        if (isNaN(input)) { return input }
        return '# ' + input;
    }
});

ngOUC.filter('buildingtype', function() {
    return function (input) {
        if (input === '' || input === null) {
            return 'Unknown';
        }

        return 'Class ' + input;
    }
});

ngOUC.filter('phonenumber', function() {
    return function (input) {
        if (!input) { return '' }
        input = String(input);
        let formattedNumber = input;
        let c = (input[0] == '1') ? '1 ' : '';
        input = input[0] == '1' ? input.slice(1) : input;
        input = input.replace(/-|\s/g,"");
        let area = input.substring(0,3);
        let front = input.substring(3, 6);
        let end = input.substring(6, 10);
        if (front) {
            formattedNumber = (c + "(" + area + ") " + front);  
        }
        if (end) {
            formattedNumber += ("-" + end);
        }
        return formattedNumber;
    };
});


// Returns a 32 bit integer hash of a string
String.prototype.hashCode = function () {
    var hash = 0;

    if (this.length == 0) {
        return hash;
    }

    for (i = 0; i < this.length; i++) {
        char = this.charCodeAt(i);

        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }

    if (hash < 0) {
        hash *= -1;
    }

    return hash;
};

function PrintReport() {
    var width  = 400;
    var height = 400;
    var left   = (screen.width / 2) - (width / 2);
    var top    = (screen.height / 2) - (height / 2);

    var printWindow = window.open('', 'Title', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);

    printWindow.document.write('<html><head><title>my div</title>');
    printWindow.document.write('<link rel="stylesheet" href="' + OucGlobals.mediaDirectory + '/../css/style.css" type="text/css" />');
    printWindow.document.write('</head><body class="property-report" style="display: block!important">');
    printWindow.document.write($('#property-report').html());
    printWindow.document.write('</body></html>');

    printWindow.document.close();
    printWindow.focus();

    printWindow.print();
    printWindow.close();

    return true;
}
